import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Icon, Circle } from './'

const pulse = keyframes`
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
`

const CircleWrap = styled.div`
  animation: ${pulse} 0.2 linear;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: ${props => (props.position ? props.position : 'absolute')};
  top: ${props => (props.top ? props.top : '5px')};
  left: ${props => (props.left ? props.left : '5px')};
  -webkit-transition: background-color 0.6s ease-in;
  -moz-transition: background-color 0.6s ease-in;
  -o-transition: background-color 0.6s ease-in;
  transition: background-color 0.6s ease-in;
  z-index: ${props => (props.position === 'static' ? 0 : props.zIndex ? props.zIndex : 9999999)};
  ${props =>
    props.active &&
    `
    & p{
    color: #078489 !important;

    }
    & svg path{
    fill: #078489 !important;

    }
  &>*{
    border-color: #078489 !important;
  }
  `};
`
const Font = styled.p`
  font-size: 7px;
  line-height: 1.57;
  color: #9a9a9a;
  padding-top: 2px;
`
class Favorite extends Component {
  static defaultProps = {
    icon: 'heart'
  }
  state = {}
  render() {
    const { active, position, icon, favValue, hideFavCount, zIndex, ...props } = this.props
    return (
      <CircleWrap active={active} position={position} zIndex={zIndex} {...props}>
        {/* <Circle size="24px" backgroundColor="#fff" border="1px solid #9a9a9a"> */}
        <Icon icon={icon} width="20" height="18" color="#9a9a9a" />
        {/* </Circle> */}
        {!hideFavCount && (
          <Circle backgroundColor="#fff" border="1px solid #9a9a9a!important" margin="-4px 0 0 0">
            <Font>{favValue || 0}</Font>
          </Circle>
        )}
      </CircleWrap>
    )
  }
}

export default Favorite



// WEBPACK FOOTER //
// ./src/components/Favorite.js